import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-back-option-section',
  templateUrl: './back-option-section.component.html',
  styleUrls: ['./back-option-section.component.scss'],
})
export class BackOptionSectionComponent {
  @Input() loading!: boolean;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  backPath() {
    let backRoute;
    this.route.params.subscribe((params) => {
      backRoute = params['backRoute'];
    });
    if (backRoute) {
      switch (backRoute) {
        case 'ad_use':
          this.router.navigate(['/admin/users']);
          break;
        case 'ad_rol':
          this.router.navigate(['/admin/users/roles']);
          break;
        case 'ad_fle':
          this.router.navigate(['/admin/fleets']);
          break;
        case 'ad_dri':
          this.router.navigate(['/admin/drivers']);
          break;
        case 'ad_sup':
          this.router.navigate(['/admin/suppliers']);
          break;
        case 'ad_cus':
          this.router.navigate(['/admin/customers']);
          break;
        case 'ad_age':
          this.router.navigate(['/admin/agents']);
          break;
        case 'ad_tra':
          this.router.navigate(['/admin/booking-transfer']);
          break;
        case 'ad_ren':
          this.router.navigate(['/admin/booking-rent']);
          break;
        case 'ad_oth':
          this.router.navigate(['/admin/booking-other']);
          break;
        default:
          this.location.back();
      }
    } else {
      this.location.back();
    }
  }
}
